module.exports = __webpack_public_path__ + "media/images/image-27852d9739d66553a51d206efbe1cf13.jpg";